import * as ActionTypes from 'constants';

export const plans = (
	state = {
		initialized: false,
		fetching_plans: false,
		creating_plan: false,
		updating_plan: false,
		removing_plan: false,
		viewing_plan_details: false,
		requesting_create_plan: false,
		requesting_update_plan: false,
		current_plan: null,
		plans_list: [],
	}, action) => {

	const { type, payload } = action;
	switch(type) {
		case ActionTypes.REQUEST_FETCH_PLANS: {
			return { ...state, fetching_plans: true };
		}
		case ActionTypes.FETCH_PLANS_SUCCESS: {
			return {
				...state,
				fetching_plans: false,
				initialized: true,
				plans_list: payload
			};
		}
		case ActionTypes.TOGGLE_REQUESTING_CREATE_PLAN: {
			return { ...state, requesting_create_plan: payload != null ? payload : !state.requesting_create_plan };
		}
		case ActionTypes.CREATE_NEW_PLAN_SUCCESS: {
			return {
				...state,
				plans_list: [ ...state.plans_list, payload ],
				requesting_create_plan: false
			};
		}
		case ActionTypes.INIT_UPDATE_PLAN: {
			return {
				...state,
				current_plan: payload,
				updating_plan: true,
				viewing_plan_details: false,
				creating_plan: false
			};
		}
		case ActionTypes.TOGGLE_REQUESTING_UPDATE_PLAN: {
			return { ...state, updating_plan: payload != null ? payload : !state.updating_plan };
		}
		case ActionTypes.UPDATE_PLAN_SUCCESS: {
			return {
				...state,
				updating_plan: false,
				plans_list: state.plans_list.map(p => p._id == payload._id ? payload : p),
				viewing_plan_details: false,
				current_plan: null
			};
		}
		case ActionTypes.INIT_VIEW_PLAN_DETAILS: {
			return {
				...state,
				viewing_plan_details: true,
				creating_plan: false,
				updating_plan: false,
				current_plan: payload
			};
		}
		case ActionTypes.TOGGLE_VIEWING_PLAN_DETAILS: {
			const canceling = payload == false ? true : state.viewing_plan_details == true;
			return {
				...state,
				viewing_plan_details: !canceling,
				current_plan: canceling ? null : state.current_plan
			}
		}
		case ActionTypes.TOGGLE_REMOVING_PLAN: {
			return { ...state, removing_plan: payload != null ? payload : !state.removing_plan };
		}
		case ActionTypes.REMOVE_PLAN_SUCCESS: {
			return {
				...state,
				plans_list: state.plans_list.filter(p => p._id != payload),
				removing_plan: false,
				current_plan: null,
				viewing_plan_details: false,
			};
		}
	}
	return state;
}



// WEBPACK FOOTER //
// ./src/common/reducers/plans.js